const comments = [
  {
    name: '吃瓜不嫌事大',
    text: '51爆料真是我的每日必刷！早上起来第一件事就是打开看今天又有什么新爆料，信息量巨大但整理得很清晰，分类做得特别好。',
    time: '2 小时前',
    tag: '忠实用户',
  },
  {
    name: '深度追踪者',
    text: '做了三年自媒体，51爆料是我最重要的信源之一。覆盖范围广、更新速度快，而且话题竞赛的形式让浏览变得很有意思，经常能看到独家视角。',
    time: '5 小时前',
    tag: '自媒体人',
  },
  {
    name: '热点雷达',
    text: '比其他平台快太多了！好几次我在这里看到爆料后，隔了半天才在其他地方刷到。真心推荐给所有追热点的朋友，每日爆料汇总功能太实用了。',
    time: '8 小时前',
    tag: '活跃用户',
  },
  {
    name: '深夜潜水员',
    text: '每晚睡前必刷一遍51爆料今日汇总，一天的瓜一个不落。大赛排行功能也很有意思，可以看到大家都在关注什么，参与感很强。',
    time: '12 小时前',
    tag: '资深用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            读者声音
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听每日大赛的读者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-3-line text-lg text-secondary-600"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">
                    {comment.time}
                  </div>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap flex-shrink-0">
                  {comment.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{comment.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}